export default __webpack_public_path__ + "static/media/ham-logo.6551afbc.svg";